import { combineReducers } from 'redux'
import { dataDeliveryReducer } from './data-delivery'

export const backOfficeReducer = combineReducers({
    dataDelivery: dataDeliveryReducer
})
